export type DevicesTypes = 'touch' | 'mouse';

export const devices: Record<DevicesTypes, string> = {
  touch: `@media (hover: none)`,
  mouse: `@media not all and (hover: none)`,
};
